import { AppState } from '../../../reducers';
import { createSelector } from '@ngrx/store';
import * as fromServiceCatalogSchemeReducer from './service-catalog-scheme.reducer';

export const currentState = (state: AppState) => (state[fromServiceCatalogSchemeReducer.serviceCatalogSchemesFeatureKey]);

export const selectAllServiceCatalogSchemes = createSelector(currentState, fromServiceCatalogSchemeReducer.selectAll);

export const selectTotalServiceCatalogSchemes = createSelector(currentState, fromServiceCatalogSchemeReducer.selectTotal);

export const selectModifiedServiceCatalogSchemes = createSelector(selectAllServiceCatalogSchemes, (serviceCatalogSchemes) => {
  return serviceCatalogSchemes.map((serviceCatalogScheme) => {
    return {
      ...serviceCatalogScheme
    };
  });
});
